module.exports = __webpack_public_path__ + "static/media/ic-ebike.5fd3bdbc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-ebike.svg
// module id = 624
// module chunks = 14